module.exports = __webpack_public_path__ + "assets/img/th-5524dfcb.png";